module.exports = __webpack_public_path__ + "img/AZ.f88a6fb0.svg";